import BasePlanCard from './BasePlanCard';

export default BasePlanCard;